export const dancerDefaultValuesModel = ({
  id,
  address,
  birthdate,
  first_name,
  last_name,
  full_name,
  email,
  phone,
  photo,
  relationships,
  measurements,
  user,
  notes,
}) => {
  return {
    id,
    user,
    birthdate: birthdate || null,
    first_name: first_name || '',
    last_name: last_name || '',
    full_name: full_name || '',
    email: email || '',
    phone: phone || '',
    measurements,
    relationships,
    avatar: photo || null,
    fullAddress: address.summary,
    city: address.city || '',
    country: { label: 'USA', value: 'USA' },
    state: address.state || { label: '', value: '' },
    address_line_1: address.address_line_1 || '',
    address_line_2: address.address_line_2 || '',
    zipcode: address.zipcode || '',
    notes: notes || [],
  };
};
